import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState('light');

    useEffect(() => {
        // Keep the brand presentation consistent for first-time and returning visitors.
        // Visitors can still change the theme afterward with the navbar control.
        localStorage.setItem('theme', 'light');
        setTheme('light');
        applyTheme('light');
    }, []);

    const applyTheme = (newTheme) => {
        if (newTheme === 'auto') {
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            // Solo log en desarrollo
            if (process.env.NODE_ENV === 'development') {
                console.log('Modo automático detectado:', prefersDark ? 'Oscuro' : 'Claro');
            }
            document.documentElement.classList.toggle('dark', prefersDark);
        } else {
            // Solo log en desarrollo
            if (process.env.NODE_ENV === 'development') {
                console.log('Modo manual:', newTheme);
            }
            document.documentElement.classList.toggle('dark', newTheme === 'dark');
        }
    };

    const toggleTheme = () => {
        const themes = ['light', 'dark', 'auto'];
        const currentIndex = themes.indexOf(theme);
        const nextTheme = themes[(currentIndex + 1) % themes.length];
        setTheme(nextTheme);
        localStorage.setItem('theme', nextTheme);
        applyTheme(nextTheme);
    };

    const isDark = theme === 'dark' || (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches);

    return (
        <ThemeContext.Provider value={{
            theme,
            toggleTheme,
            isDark
        }}>
            {children}
        </ThemeContext.Provider>
    );
};
